import { type UseQueryResult, useQuery } from 'react-query';
import { OptionAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useOptionAwardParticipantStatusOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const optionAwardParticipantStatus = useQuery(
    ['getOptionAwardParticipantStatus'],
    async () => {
      return await handleRequest(
        OptionAwardService.getApiAwardApiAppOptionAwardOptionAwardStatuses()
      );
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
        const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return optionAwardParticipantStatus;
};

export default useOptionAwardParticipantStatusOptions;
